<template>
    <section id="personal-detail">
        <form @submit.prevent="">
            <div class="row">
                <div class="col-lg-6 offset-lg-3 col-12 p-0">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <p class="h5">ข้อมูลส่วนตัว</p>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="product-code"><span class="text-danger">*</span>ผลิตภัณฑ์</label>
                                        <input v-model="productCode" type="text"
                                                class="form-control "
                                                id="product-code" >
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="branch-code"><span class="text-danger">*</span>สาขา</label>
                                            <input v-model="branchCode" type="text"
                                                    class="form-control "
                                                    id="branch-code" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label  for="partner-ref-no"><span class="text-danger">*</span>เลขที่อ้างอิง</label>
                                        <input v-model="partnerRefNo" type="text"
                                                class="form-control "
                                                id="partner-ref-no" >
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="prename-thai"><span class="text-danger">*</span>คำนำหน้าชื่อ (ไทย) </label>
                                            <select v-model="prenameThai" class="form-control " id="prename-thai" >
                                                <option v-for="item in ['นาย', 'นาง', 'นางสาว', 'อื่นๆ']" :key="item" :value="item"> {{ item }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label  for="prename-eng">คำนำหน้าชื่อ (อังกฤษ) </label>
                                        <select v-model="prenameEng" class="form-control " id="prename-eng">
                                            <option v-for="item in ['Mr.', 'Mrs.', 'Ms.', 'Other']" :key="item" :value="item"> {{ item }}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="thai-name"><span class="text-danger">*</span>ชื่อ-นามสกุล ภาษาไทย</label>
                                            <input v-model="thaiName" type="text"
                                                    class="form-control "
                                                    id="thai-name" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="eng-name"><span class="text-danger">*</span>ชื่อ-นามสกุล ภาษาอังกฤษ</label>
                                        <input v-model="engName" type="text"
                                                class="form-control "
                                                id="eng-name" >
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="birthday">วันเกิด </label>
                                            <b-form-datepicker id="birthday" locale="th" class="mb-2" placeholder="DD-MM-YYYY" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" v-model="birthday"></b-form-datepicker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                  <div class="form">
                                      <div class="form-group">
                                          <label for="age">อายุ</label>
                                          <input v-model="age" type="text"
                                                  class="form-control "
                                                  id="age">
                                      </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                  <div class="form">
                                      <div class="form-group">
                                          <label for="nationality"><span class="text-danger">*</span>สัญชาติ</label>
                                          <input v-model="nationality" type="text"
                                                  class="form-control "
                                                  id="nationality" >
                                      </div>
                                  </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="idcard"><span class="text-danger">*</span>เลขที่บัตรประชาชน</label>
                                            <input v-model="idcard" type="text"
                                                    class="form-control "
                                                    id="idcard" >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                  <div class="form">
                                      <div class="form-group">
                                          <label for="idcard-expire-date"><span class="text-danger">*</span>วันหมดอายุบัตรประชาชน</label>
                                          <b-form-datepicker id="idcard-expire-date" locale="th" class="mb-2" placeholder="DD-MM-YYYY" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" v-model="idcardExpireDate" ></b-form-datepicker>
                                          <!-- <input v-model="idcardExpireDate" type="text"
                                                  class="form-control "
                                                  id="">-->
                                      </div>
                                  </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="marriage-status">สถานภาพ</label>
                                            <select v-model="marriageStatus"  class="form-control " id="marriage-status" >
                                            <option v-for="item in ['โสด','สมรส','หย่า']" :key="item" :value="item"> {{ item }}</option>
                                        </select>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                  <div class="form">
                                      <div class="form-group">
                                          <label for="living-status">สถานะของการอยู่อาศัย</label>

                                                  <select v-model="livingStatus"  class="form-control " id="living-status" >
                                              <option v-for="item in ['บ้านตนเองปลอดภาระ','บ้านตนเองกำลังผ่อน','บิดาร/มารดา','บ้านญาติ/พี่น้อง/บุคคลอื่น','สวัสดิการ','เช่าอยู่']" :key="item" :value="item"> {{ item }}</option>
                                          </select>

                                      </div>
                                  </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="current-building">ชื่อหมู่บ้าน/อาคารชุด</label>
                                            <input v-model="currentBuilding" type="text"
                                                    class="form-control "
                                                    id="current-building">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                  <div class="form">
                                      <div class="form-group">
                                          <label for="current-room-no">เลขที่ห้องชั้น</label>
                                          <input v-model="currentRoomNo" type="text"
                                                  class="form-control "
                                                  id="current-room-no">
                                      </div>
                                  </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="current-address-modal">บ้านเลขที่</label>
                                            <input v-model="currentAddressModal" type="text"
                                                    class="form-control "
                                                    id="current-address-modal">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                  <div class="form">
                                      <div class="form-group">
                                          <label for="current-moo">หมู่</label>
                                          <input v-model="currentMoo" type="text"
                                                  class="form-control "
                                                  id="current-moo">
                                      </div>
                                  </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="current-soi">ซอย</label>
                                            <input v-model="currentSoi" type="text"
                                                    class="form-control "
                                                    id="current-soi">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                  <div class="form">
                                      <div class="form-group">
                                          <label for="current-road">ถนน</label>
                                          <input v-model="currentRoad" type="text"
                                                  class="form-control "
                                                  id="current-road">
                                      </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                  <div class="form">
                                      <div class="form-group">
                                          <label for="current-text-address">ที่อยู่</label>
                                          <!-- currentTextAddress -->
                                          <v-select id="current-text-address" v-model="currentTextAddress" :options="currentOptionsAddress" label="texts"
                                                    @search="(search) => {
                                                    fetchAddress(search)}">
                                            <template v-slot:option="option">
                                              <span :class="option.texts"></span>
                                              {{ option.texts }}
                                            </template>
                                          </v-select>

                                      </div>
                                  </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <div class="form">
                                    <div class="form-group">
                                        <label for="mobile">โทรศัพท์มือถือ</label>
                                        <input v-model="mobile" type="text"
                                                class="form-control "
                                                id="mobile">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <div class="form">
                                    <div class="form-group">
                                        <label for="phone">เบอร์โทรศัพท์(สำรอง)</label>
                                        <input v-model="phone" type="text"
                                                class="form-control "
                                                id="phone">
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <div class="form">
                                    <div class="form-group">
                                        <label for="email">e-mail</label>
                                        <input v-model="email" type="text"
                                                class="form-control "
                                                id="email">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <div class="form">
                                    <div class="form-group">
                                        <label for="lineId">line</label>
                                        <input v-model="lineId" type="text"
                                                class="form-control "
                                                id="lineId">
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <div class="form">
                                    <div class="form-group">
                                        <label for="facebook">facebook</label>
                                        <input v-model="facebook" type="text"
                                                class="form-control "
                                                id="facebook">
                                    </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <div class="form">
                                    <div class="form-group">
                                        <label for="documents-receive">ที่อยู่รับเอกสาร</label>
                                        <input v-model="documentsReceive" type="text"
                                                class="form-control "
                                                id="documents-receive">
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <p class="h5">อาชีพ/สถานที่ทำงาน</p>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="occupation"><span class="text-danger">*</span>อาชีพ</label>

                                        <select v-model="occupation"  class="form-control " id="occupation" >
                                            <option v-for="item in ['รับราชการ','พนักงานรัฐวิสาหกิจ','พนักงานบริษัท','เจ้าของกิจการที่จดทะเบียนพานิชย์','พ่อบ้าน/แม่บ้าน','อาชีพอิสระ','กิจการส่วนตัว','พนักงานรายวัน/ชั่วคราว']" :key="item" :value="item"> {{ item }}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="office-name"><span class="text-danger">*</span>ชื่อสถานที่ทำงาน</label>
                                            <input v-model="officeName" type="text"
                                                    class="form-control "
                                                    id="office-name" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="office-building">ชื่อหมู่บ้าน/อาคารชุด</label>
                                        <input v-model="officeBuilding" type="text"
                                                class="form-control "
                                                id="office-building">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="">เลขที่ห้องชั้น</label>
                                            <input v-model="officeRoomNo" type="text"
                                                    class="form-control "
                                                    id="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="office-address">บ้านเลขที่</label>
                                        <input v-model="officeAddress" type="text"
                                                class="form-control "
                                                id="office-address">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="office-moo">หมู่</label>
                                            <input v-model="officeMoo" type="text"
                                                    class="form-control "
                                                    id="office-moo">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="office-soi">ซอย</label>
                                        <input v-model="officeSoi" type="text"
                                                class="form-control "
                                                id="office-soi">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="office-road">ถนน</label>
                                            <input v-model="officeRoad" type="text"
                                                    class="form-control "
                                                    id="office-road">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="office_address"><span class="text-danger">*</span>ที่อยู่</label>
                                        <v-select v-model="officeTextAddress" :options="officeOptionsAddress" label="texts"
                                                  id="office_address"

                                                  @search="(search) => {
                                                  fetchAddress(search)}">
                                          <template v-slot:option="option">
                                            <span :class="option.texts"></span>
                                            {{ option.texts }}
                                          </template>
                                        </v-select>
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="office-phone"><span class="text-danger">*</span>โทรศัพท์</label>
                                            <input v-model="officePhone" type="text"
                                                    class="form-control "
                                                    id="office-phone" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="office-business-type">ประเภทธุรกิจ</label>
                                        <input v-model="officeBusinessType" type="text"
                                                class="form-control "
                                                id="office-business-type">
                                    </div>
                                </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <p class="h5">รายได้</p>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="income"><span class="text-danger">*</span>รายได้/เดือน</label>
                                        <input v-model="income" type="text"
                                                class="form-control "
                                                id="income" >
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="other-income">รายได้อื่น (ถ้ามี)</label>
                                            <input v-model="otherIncome" type="text"
                                                    class="form-control "
                                                    id="other-income">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label  for="income-source">แหล่งที่มารายได้</label>

                                        <select v-model="incomeSource" class="form-control " id="income-source">
                                            <option v-for="item in ['รับจ้าง/เงินเดือน','ธุรกิจส่วนตัว','โบนัส','ค่าคอม','อื่นๆ']" :key="item" :value="item"> {{ item }}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form">
                                    <div class="form-group">

                                        <label  for="other-income-source">แหล่งที่มารายได้อื่นๆ</label>
                                        <select v-model="otherIncomeSource" class="form-control " id="other-income-source">
                                            <option v-for="item in ['รับจ้าง/เงินเดือน','ธุรกิจส่วนตัว','โบนัส','ค่าคอม','อื่นๆ']" :key="item" :value="item"> {{ item }}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="invoice-location"><span class="text-danger">*</span>สถานที่ส่งใบแจ้งยอด/ใบเสร็จการชำระเงินกู้ และเอกสารอื่นๆ</label>
                                            <select v-model="invoiceLocation" class="form-control " id="invoice-location">
                                              <option v-for="item in ['ที่ทำงาน','ที่อยู่ปัจจุบัน','อีเมล']" :key="item" :value="item"> {{ item }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <p class="h5">วงเงินกู้</p>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="campaign">*CAMPAIGN</label>
                                        <select v-model="campaign" class="form-control " id="campaign" >
                                            <option v-for="item in ['Beneat']" :key="item" :value="item"> {{ item }}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="loan-amt">*จำนวนเงินที่ขอกู้ เลือกวงเงิน</label>
                                            <input v-model="loanAmt" type="text"
                                                    class="form-control "
                                                    id="loan-amt" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="loan-installment">*ระยะเวลาผ่อนชำระ (เดือน) เลือกระยะเวลา</label>
                                        <input v-model="loanInstallment" type="text"
                                                class="form-control "
                                                id="loan-installment" >
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="account-name"><span class="text-danger">*</span>ชื่อบัญชี ดึงมาหน้าส่วนแรกข้อมูลส่วนตัวชื่อ-สกุล</label>
                                            <input v-model="accountName" type="text"
                                                    class="form-control "
                                                    id="account-name" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="bank-account-no"><span class="text-danger">*</span>เลขที่บัญชี</label>
                                        <input v-model="bankAccountNo" type="text"
                                                class="form-control "
                                                id="bank-account-no" >
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card shadow-sm">
                        <div class="card-body">
                            <p class="h5">ผู้ค้ำ</p>
                            <hr>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="guarantor-prename">คำนำหน้าชื่อ (ภาษาไทย)</label>
                                        <input v-model="guarantorPrename" type="text"
                                                class="form-control "
                                                id="guarantor-prename">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="guarantor-thai-name">ชื่อ-นามสกุลผู้ค้ำ</label>
                                            <input v-model="guarantorThaiName" type="text"
                                                    class="form-control "
                                                    id="guarantor-thai-name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="guarantor-age">อายุ</label>
                                        <input v-model="guarantorAge" type="text"
                                                class="form-control "
                                                id="guarantor-age">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="guarantor-origin">เชื้อชาติ</label>
                                            <input v-model="guarantorOrigin" type="text"
                                                    class="form-control "
                                                    id="guarantor-origin">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="guarantor-nationality">สัญชาติ</label>
                                        <input v-model="guarantorNationality" type="text"
                                                class="form-control "
                                                id="guarantor-nationality">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="guarantor-building">ชื่อหมู่บ้าน/อาคารชุด</label>
                                            <input v-model="guarantorBuilding" type="text"
                                                    class="form-control "
                                                    id="guarantor-building">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="guarantor-room-no">เลขที่ห้องชั้น</label>
                                        <input v-model="guarantorRoomNo" type="text"
                                                class="form-control "
                                                id="guarantor-room-no">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="guarantor-address">บ้านเลขที่</label>
                                            <input v-model="guarantorAddress" type="text"
                                                    class="form-control "
                                                    id="guarantor-address">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="guarantor-moo">หมู่</label>
                                        <input v-model="guarantorMoo" type="text"
                                                class="form-control "
                                                id="guarantor-moo">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="guarantor-soi">ซอย</label>
                                            <input v-model="guarantorSoi" type="text"
                                                    class="form-control "
                                                    id="guarantor-soi">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="guarantor-road">ถนน</label>
                                        <input v-model="guarantorRoad" type="text"
                                                class="form-control "
                                                id="guarantor-road">
                                    </div>
                                </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="guarantor-text-address"><span class="text-danger">*</span>ที่อยู่</label>
                                            <v-select id="guarantor-text-address" v-model="guarantorTextAddress" :options="officeOptionsAddress" label="texts"
                                                  @search="(search) => {
                                                  fetchAddress(search)}">
                                              <template v-slot:option="option">
                                                <span :class="option.texts"></span>
                                                {{ option.texts }}
                                              </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 ">
                                <div class="form">
                                    <div class="form-group">
                                        <label for="guarantor-idcard">เลขบัตรประชาชน</label>
                                        <input v-model="guarantorIdcard" type="text"
                                                class="form-control "
                                                id="guarantor-idcard"
                                                >
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
export default {
  components: {
    'v-select': vSelect
  },
  computed: {
    ...mapGetters({
      nimcapDetils: 'nimcap/GET_DETAILS'
    }),
    productCode: {
      get () {
        return this.nimcapDetils.productCode
      },
      set (val) {
        let payload = {
          main_key: 'productCode',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    branchCode: {
      get () {
        return this.nimcapDetils.branchCode
      },
      set (val) {
        let payload = {
          main_key: 'branchCode',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    partnerRefNo: {
      get () {
        return this.nimcapDetils.partnerRefNo
      },
      set (val) {
        let payload = {
          main_key: 'partnerRefNo',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    prenameThai: {
      get () {
        return this.nimcapDetils.prenameThai
      },
      set (val) {
        let payload = {
          main_key: 'prenameThai',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    thaiName: {
      get () {
        return this.nimcapDetils.thaiName
      },
      set (val) {
        let payload = {
          main_key: 'thaiName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    prenameEng: {
      get () {
        return this.nimcapDetils.prenameEng
      },
      set (val) {
        let payload = {
          main_key: 'prenameEng',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    engName: {
      get () {
        return this.nimcapDetils.engName
      },
      set (val) {
        let payload = {
          main_key: 'engName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    birthday: {
      get () {
        return this.nimcapDetils.birthday
      },
      set (val) {
        let payload = {
          main_key: 'birthday',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    age: {
      get () {
        return this.nimcapDetils.age
      },
      set (val) {
        let payload = {
          main_key: 'age',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    nationality: {
      get () {
        return this.nimcapDetils.nationality
      },
      set (val) {
        let payload = {
          main_key: 'nationality',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    idcard: {
      get () {
        return this.nimcapDetils.idcard
      },
      set (val) {
        let payload = {
          main_key: 'idcard',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    idcardExpireDate: {
      get () {
        return this.nimcapDetils.idcardExpireDate
      },
      set (val) {
        let payload = {
          main_key: 'idcardExpireDate',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    marriageStatus: {
      get () {
        return this.nimcapDetils.marriageStatus
      },
      set (val) {
        let payload = {
          main_key: 'marriageStatus',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    livingStatus: {
      get () {
        return this.nimcapDetils.livingStatus
      },
      set (val) {
        let payload = {
          main_key: 'livingStatus',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    mobile: {
      get () {
        return this.nimcapDetils.mobile
      },
      set (val) {
        let payload = {
          main_key: 'mobile',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    phone: {
      get () {
        return this.nimcapDetils.phone
      },
      set (val) {
        let payload = {
          main_key: 'phone',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    email: {
      get () {
        return this.nimcapDetils.email
      },
      set (val) {
        let payload = {
          main_key: 'email',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    lineId: {
      get () {
        return this.nimcapDetils.lineId
      },
      set (val) {
        let payload = {
          main_key: 'lineId',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    facebook: {
      get () {
        return this.nimcapDetils.facebook
      },
      set (val) {
        let payload = {
          main_key: 'facebook',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    documentsReceive: {
      get () {
        return this.nimcapDetils.documentsReceive
      },
      set (val) {
        let payload = {
          main_key: 'documentsReceive',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    occupation: {
      get () {
        return this.nimcapDetils.occupation
      },
      set (val) {
        let payload = {
          main_key: 'occupation',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    income: {
      get () {
        return this.nimcapDetils.income
      },
      set (val) {
        let payload = {
          main_key: 'income',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    otherIncome: {
      get () {
        return this.nimcapDetils.otherIncome
      },
      set (val) {
        let payload = {
          main_key: 'otherIncome',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    incomeSource: {
      get () {
        return this.nimcapDetils.incomeSource
      },
      set (val) {
        let payload = {
          main_key: 'incomeSource',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    otherIncomeSource: {
      get () {
        return this.nimcapDetils.otherIncomeSource
      },
      set (val) {
        let payload = {
          main_key: 'otherIncomeSource',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    invoiceLocation: {
      get () {
        return this.nimcapDetils.invoiceLocation
      },
      set (val) {
        let payload = {
          main_key: 'invoiceLocation',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    invoice_location: {
      get () {
        return this.nimcapDetils.invoice_location
      },
      set (val) {
        let payload = {
          main_key: 'invoice_location',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    campaign: {
      get () {
        return this.nimcapDetils.campaign
      },
      set (val) {
        let payload = {
          main_key: 'campaign',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    loanAmt: {
      get () {
        return this.nimcapDetils.loanAmt
      },
      set (val) {
        let payload = {
          main_key: 'loanAmt',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    loanInstallment: {
      get () {
        return this.nimcapDetils.loanInstallment
      },
      set (val) {
        let payload = {
          main_key: 'loanInstallment',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    accountName: {
      get () {
        return this.nimcapDetils.accountName
      },
      set (val) {
        let payload = {
          main_key: 'accountName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    bankCode: {
      get () {
        return this.nimcapDetils.bankCode
      },
      set (val) {
        let payload = {
          main_key: 'bankCode',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    bankAccountNo: {
      get () {
        return this.nimcapDetils.bankAccountNo
      },
      set (val) {
        let payload = {
          main_key: 'bankAccountNo',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentBuilding: {
      get () {
        return this.nimcapDetils.currentAddress.building
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'building',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentRoomNo: {
      get () {
        return this.nimcapDetils.currentAddress.roomNo
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'roomNo',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentAddressModal: {
      get () {
        return this.nimcapDetils.currentAddress.address
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'address',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentMoo: {
      get () {
        return this.nimcapDetils.currentAddress.moo
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'moo',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentSoi: {
      get () {
        return this.nimcapDetils.currentAddress.soi
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'soi',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentRoad: {
      get () {
        return this.nimcapDetils.currentAddress.road
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'road',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentSubDistrictName: {
      get () {
        return this.nimcapDetils.currentAddress.subDistrictNamex
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'subDistrictName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentDistrictName: {
      get () {
        return this.nimcapDetils.currentAddress.districtName
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'districtName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentProvinceName: {
      get () {
        return this.nimcapDetils.currentAddress.provinceName
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'provinceName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentZipcode: {
      get () {
        return this.nimcapDetils.currentAddress.zipcode
      },
      set (val) {
        let payload = {
          main_key: 'currentAddress',
          sub_key: 'zipcode',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    currentTextAddress: {
      get () {
        return this.nimcapDetils.currentAddress.textAddress
      },
      set (val) {
        let payloadText = {
          main_key: 'currentAddress',
          sub_key: 'textAddress',
          value: val.texts
        }
        this.SET_EL_VALUE(payloadText)
        let payloadProvince = {
          main_key: 'currentAddress',
          sub_key: 'provinceName',
          value: val.province_name
        }
        this.SET_EL_VALUE(payloadProvince)
        let payloadDistrict = {
          main_key: 'currentAddress',
          sub_key: 'districtName',
          value: val.disreict_name
        }
        this.SET_EL_VALUE(payloadDistrict)
        let payloadSubDistrict = {
          main_key: 'currentAddress',
          sub_key: 'subDistrictName',
          value: val.subdistrict_name
        }
        this.SET_EL_VALUE(payloadSubDistrict)
        let payloadZipcode = {
          main_key: 'currentAddress',
          sub_key: 'zipcode',
          value: val.zipcode
        }
        this.SET_EL_VALUE(payloadZipcode)
      }
    },
    officeName: {
      get () {
        return this.nimcapDetils.office.name
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'name',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    officeBuilding: {
      get () {
        return this.nimcapDetils.office.building
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'building',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    officeRoomNo: {
      get () {
        return this.nimcapDetils.office.roomNo
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'roomNo',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    officeAddress: {
      get () {
        return this.nimcapDetils.office.address
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'address',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    officeMoo: {
      get () {
        return this.nimcapDetils.office.moo
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'moo',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    officeSoi: {
      get () {
        return this.nimcapDetils.office.soi
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'soi',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    officeRoad: {
      get () {
        return this.nimcapDetils.office.road
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'road',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    officeTextAddress: {
      get () {
        return this.nimcapDetils.office.textAddress
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'textAddress',
          value: val.texts
        }
        this.SET_EL_VALUE(payload)
        let payloadProvince = {
          main_key: 'office',
          sub_key: 'provinceName',
          value: val.province_name
        }
        this.SET_EL_VALUE(payloadProvince)
        let payloadDistrict = {
          main_key: 'office',
          sub_key: 'districtName',
          value: val.disreict_name
        }
        this.SET_EL_VALUE(payloadDistrict)
        let payloadSubDistrict = {
          main_key: 'office',
          sub_key: 'subDistrictName',
          value: val.subdistrict_name
        }
        this.SET_EL_VALUE(payloadSubDistrict)
        let payloadZipcode = {
          main_key: 'office',
          sub_key: 'zipcode',
          value: val.zipcode
        }
        this.SET_EL_VALUE(payloadZipcode)
      }
    },
    officePhone: {
      get () {
        return this.nimcapDetils.office.phone
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'phone',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    officeBusinessType: {
      get () {
        return this.nimcapDetils.office.businessType
      },
      set (val) {
        let payload = {
          main_key: 'office',
          sub_key: 'businessType',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorPrename: {
      get () {
        return this.nimcapDetils.guarantor.prename
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'prename',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorThaiName: {
      get () {
        return this.nimcapDetils.guarantor.thaiName
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'thaiName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorAge: {
      get () {
        return this.nimcapDetils.guarantor.age
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'age',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorOrigin: {
      get () {
        return this.nimcapDetils.guarantor.origin
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'origin',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorNationality: {
      get () {
        return this.nimcapDetils.guarantor.nationality
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'nationality',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorBuilding: {
      get () {
        return this.nimcapDetils.guarantor.building
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'building',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorRoomNo: {
      get () {
        return this.nimcapDetils.guarantor.roomNo
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'roomNo',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorAddress: {
      get () {
        return this.nimcapDetils.guarantor.address
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'address',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorMoo: {
      get () {
        return this.nimcapDetils.guarantor.moo
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'moo',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorSoi: {
      get () {
        return this.nimcapDetils.guarantor.soi
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'soi',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorRoad: {
      get () {
        return this.nimcapDetils.guarantor.road
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'road',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorTextAddress: {
      get () {
        return this.nimcapDetils.guarantor.textAddress
      },
      set (val) {
        let payloadText = {
          main_key: 'guarantor',
          sub_key: 'textAddress',
          value: val.texts
        }
        this.SET_EL_VALUE(payloadText)
        let payloadProvince = {
          main_key: 'guarantor',
          sub_key: 'provinceName',
          value: val.province_name
        }
        this.SET_EL_VALUE(payloadProvince)
        let payloadDistrict = {
          main_key: 'guarantor',
          sub_key: 'districtName',
          value: val.disreict_name
        }
        this.SET_EL_VALUE(payloadDistrict)
        let payloadSubDistrict = {
          main_key: 'guarantor',
          sub_key: 'subDistrictName',
          value: val.subdistrict_name
        }
        this.SET_EL_VALUE(payloadSubDistrict)
        let payloadZipcode = {
          main_key: 'guarantor',
          sub_key: 'zipcode',
          value: val.zipcode
        }
        this.SET_EL_VALUE(payloadZipcode)
      }
    },
    /*
    guarantorSubDistrictName: {
      get () {
        return this.nimcapDetils.guarantor.subDistrictName
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'subDistrictName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorDistrictName: {
      get () {
        return this.nimcapDetils.guarantor.districtName
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'districtName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorProvinceName: {
      get () {
        return this.nimcapDetils.guarantor.provinceName
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'provinceName',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    },
    guarantorZipcode: {
      get () {
        return this.nimcapDetils.guarantor.zipcode
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'zipcode',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    }, */
    guarantorIdcard: {
      get () {
        return this.nimcapDetils.guarantor.idcard
      },
      set (val) {
        let payload = {
          main_key: 'guarantor',
          sub_key: 'idcard',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    }
  },
  data: () => ({
    officeOptionsAddress: [],
    currentOptionsAddress: []
  }),
  methods: {
    ...mapActions({
      SET_EL_VALUE: 'nimcap/SET_EL_VALUE'
    }),
    async fetchAddress (keyword = null) {
      if (!keyword) keyword = ''
      try {
        const { data } = await axios.get('/nimcap/address', {params: {keyword: keyword}})
        if (!data.error) {
          this.officeOptionsAddress = data.address
          this.currentOptionsAddress = data.address
        }
      } catch (err) {
        console.log(err)
      }
    },
    fetchProfessional (proId, token) {
      try {
        const { data } = axios.get('/nimcap', {params: {professional_id: proId, token: token}})
        if (!data.error) {
          console.log(data)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async fetchOptions (search) {
      const { data } = await axios.get('/nimcap/text-address', {params: {keyword: search}})
      if (!data.error) {
        this.optionsAddress = data.address
      }
    }
  },
  mounted () {
    this.fetchAddress()
  }
}
</script>
<style lang="scss">
section#personal-detail {
  input:invalid {
    border: 2px solid red;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/nimcap/Components/Form/PersonalDetail.vue